<template>
  <v-app-bar app elevate-on-scroll  :color="$vuetify.theme.dark ? '#121212' : 'white'"
  class="full-width px-2 px-md-5">
    <v-hover v-slot="{ hover }">
      <div class="d-flex justify-start align-center ma-0 pa-0" >
        <div class="d-flex justify-start align-center" @click="navigateToLinkBack()"
        :style="{ 'cursor': hover ? 'pointer' : 'default' }">
        <v-img v-if="$vuetify.theme.dark" :src="require('../assets/companyLogoDark.png')" class="ml-0 mr-2" contain
          height="35" />
        <v-img v-else :src="require('../assets/companyLogoLight.png')" class="ml-0 mr-2" contain height="30" />
        <v-app-bar-title>
          <span  class="app-name text--primary"  >
            {{ appDetails.linkBack.name }}
          </span>
        </v-app-bar-title>
        <!-- :color="$vuetify.theme.dark ? 'grey darken-2' : 'grey'" -->
      </div>
      <span class="mx-2 display-1 font-weight-light text-secondary">|</span>

      <div class="d-flex justify-start align-center" @click="navigateToHome()"
        :style="{ 'cursor': hover ? 'pointer' : 'default' }">
        <v-app-bar-title >
          <span  class="app-parent-name primary--text text--accent-4"  >
            {{ appDetails.name }}
          </span>
        </v-app-bar-title>
      </div>
      </div>
    </v-hover>
    <v-spacer></v-spacer>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon @click="toggleTheme()" class="change-theme" v-bind="attrs" v-on="on">
          <v-icon>{{ $vuetify.theme.dark ? 'mdi-white-balance-sunny' : 'mdi-brightness-2' }}</v-icon>
        </v-btn>
      </template>
      <span>Change theme</span>
    </v-tooltip>
    <div class="d-md-none mr-2"></div>
    <div class="d-none d-md-flex mr-5"></div>
        <AppBarMenu />
  </v-app-bar>

</template>

<script>
import FeatureService from '@/services/FeatureService'
import AppBarMenu from './AppBarMenu.vue'
// import { acquireToken } from '../services/AuthService'

export default {
  name: 'app-bar',
  components: {
    AppBarMenu
  },
  data () {
    return {
      searchTerm: '',
      showConnectorsDialog: false,
      profileMenu: true,
      search: '',
      allItems: [],
      items: [],
      select: null,
      loading: false,
      appDetails: {
        linkBack: {
          url: process.env.VUE_APP_LINKBACK_URL,
          name: 'Enterprise Automation'
        },
        name: 'AppBridge',
        logo: '../assets/companyLogo.png'
      },
      navigations: [
        // { name: 'Search', link: '/', icon: 'mdi-magnify' },
        { name: 'Favourites', link: '/', icon: 'mdi-heart' },
        { name: 'More', link: '/', icon: 'mdi-dots-vertical' }
      ]
    }
  },
  methods: {
    openAllConnectors () {
      this.showConnectorsDialog = true
    },
    onMenuClick () {
      console.log('menu clicked')
      this.$emit('toggle-drawer')
    },
    navigateToHome () {
      this.$router.push('/')
    },
    navigateToLinkBack () {
      // open in a new tab  this.appDetails.linkBack.url
      window.open(this.appDetails.linkBack.url, '_blank')
    },
    toggleTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      localStorage.setItem('isDarkTheme', this.$vuetify.theme.dark)
    },
    querySelections (v) {
      this.loading = true
      setTimeout(() => {
        console.log('searching for', v)
        // Filter the allItems array based on the search input
        this.items = this.allItems.filter(item => item.title.toLowerCase().includes(v.toLowerCase()))
        this.loading = false
      }, 500)
    },
    fetchFeatures () {
      this.loading = true
      FeatureService.getFeatures({ connector: 'all' }, this.$userInfo.profile.accessToken)
        .then(response => {
          this.allItems = response.data
          this.items = this.allItems
          this.loading = false
        })
        .catch(e => {
          this.loading = false
        })
    },
    navigateToFeature (feature) {
      // console.log(feature)
      this.$router.push({
        name: 'Feature',
        params: { id: feature.id },
        query: {}
      })
    }
  },
  watch: {
    search (val) {
      console.log(val)
      if (!val || this.loading) return
      val && val !== this.select && this.querySelections(val)
    }
  },
  mounted () {
    // this.$emit('toggle-drawer')
    this.fetchFeatures()
  }
}
</script>

<style></style>
